import { render, staticRenderFns } from "./BusinessOpportunityMine.vue?vue&type=template&id=3d916c7b&scoped=true"
import script from "./BusinessOpportunityMine.vue?vue&type=script&lang=js"
export * from "./BusinessOpportunityMine.vue?vue&type=script&lang=js"
import style0 from "./BusinessOpportunityMine.vue?vue&type=style&index=0&id=3d916c7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d916c7b",
  null
  
)

export default component.exports